import common from '../common';

export default {
  ...common,
  selectCompany: 'Vælg en virksomhed',
};
